export * from '../../../../../module/dev/constants/languages';

export const ONLINE = 'common.online';
export const OFFLINE = 'common.offline';
export const CUSTOMER_SUPPORT = 'common.header.customer-support';
export const COLOR_THEME = 'common.color-theme';
export const LOGOUT = 'room.header.logout';
export const AWAY = 'room.away';
export const DOWNLOAD_APP = 'room.tabs.footer.download-app';
export const LEAVE_ROOM = 'room.tabs.leave-room';
export const ACCEPT_CALL = 'room.tabs.accept-call';
export const WINDOWS = 'room.tabs.download.windows';
export const MAC = 'room.tabs.download.mac';
export const LINUX = 'room.tabs.download.linux';
export const AUTO_ACCEPT = 'room.chat-auto-accept';
export const AUTO_ACCEPT_HINT_WHEN_DISABLE = 'room.chat-auto-accept.hint-when-disable';
export const TYPING = 'room.typing';
export const INPUT_AREA_PLACEHOLDER = 'room.message-input-area.placeholder';
export const SELECT_CANNED_RESPONSE = 'room.canned-response.select';
export const SEARCH_CANNED_RESPONSE = 'side-bar.canned-response.search';
export const NO_CHATS = 'side-bar.canned-response.no-chats';
export const QUICK_TEXTS = 'side-bar.canned-response.quick-texts';
export const INSERT_CANNED_RESPONSE = 'side-bar.canned-response.insert';
export const VISITOR_DETAILS = 'side-bar.canned-response.details';
export const TECHNOLOGY = 'side-bar.canned-response.technology';
// export const INSERT_CANNED_RESPONSE = 'chat.caller.tooltip.insert-canned-response';
export const SEND_TRANSCRIPT_CONFIRM = 'chat.caller.send-transcript-by-email.confirmation.window.title';
export const BACK_TO_CHAT = 'room.back-to-chat';
export const SEND_MESSAGE = 'room.input-message-area.send-message';
export const OPERATORS = 'room.info-pane.operators';
export const VISITORS = 'room.info-pane.visitors';
export const STATUS = 'room.info-pane.status';
export const NICKNAME = 'room.info-pane.nickname';
export const FULLNAME = 'room.info-pane.fullName';
export const DEPARTAMENTS = 'room.info-pane.departments';
export const EMAIL_ADRESS = 'room.info-pane.email';
export const ROOMS = 'room.info-pane.rooms';
export const ROOM = 'room.info-pane.visitor-invite-hint';
export const VISITOR_TALKING = 'room.info-pane.visitor-talking-hint';
export const OPTIONS = 'room.info-pane.options';
export const DETAILS = 'room.info-pane.details';
export const IP_HOST = 'room.info-pane.ip-host';
export const HITS_DURATION = 'room.info-pane.hits-duration';
export const DURATION = 'room.info-pane.duration'
export const LOCATION = 'room.info-pane.location';
export const BROWSER = 'room.info-pane.userAgent';
export const REFERRER = 'room.info-pane.referrer';
export const CALL = 'room.info-pane.call-hint';
export const VISITOR_HINT_ROOM = 'room.info-pane.visitor-room-hint';
export const INVITE = 'room.info-pane.invite-hint';
export const PAGES = 'room.info-pane.pages-hint';
export const BACK_TO_VISITORS = 'room.info-pane.back-to-visitors';
export const TIME = 'room.info-pane.time';
export const NO_VISITORS = 'room.info-pane.no-visitors';
export const ACCOUNT_NAME = 'login.account-name';
export const OPERATOR_ERROR = 'login.operator-error';
export const OPERATOR_LOGIN = 'login.operator-login';
export const OPERATOR_PASS = 'login.operator-pass';
export const AUTO_LOGIN = 'login.auto-login';
export const LOGIN_BTN = 'login.login-btn';
export const FORGOT_PASS = 'login.forgot-pass';
export const RECOVERY_TITLE = 'login.pass-recovery.title';
export const RECOVERY_EXPLANATION = 'login.pass-recovery.explanation';
export const RECOVERY_SUCCESS = 'login.pass-recovery.success.send-pass';
export const LOGIN_NO_EMAIL = 'login.has-not-email';
export const RECOVERY_SUCCESS_THANKS = 'login.pass-recovery.success.thanks';
export const RECOVERY_SUCCESS_EXPLANATION = 'login.pass-recovery.success.explanation';
export const CONTACT_ADMIN = 'login.please-contact-admin';
export const LOGIN_RETURN = 'login.return';
export const PLAY_MESSAGE_ALERT = 'settings.play-message-alert';
export const PLAY_NEW_VISITOR_ALERT = 'settings.play-new-visitor-alert';
export const PLAY_VISITOR_CALL_ALERT = 'settings.play-visitor-call-alert';
export const SHOW_LINK_PREVIEW = 'settings.show-link-preview';
export const RTL_SETTING = 'settings.rtl';
export const NOTIFICATION_MSG_RECEIVED = 'notification.message-received';
export const NOTIFICATION_NEW_CALL_FIRST = 'notification.new-call-first-part';
export const NOTIFICATION_NEW_CALL_SECOND = 'notification.new-call-second-part';
export const NOTIFICATION_ALERT = 'notification.alert';
export const ALLOW_NOTIFICATIONS = 'notification.allow-request';
export const DELETE_MESSAGE = 'room.delete-message';
export const EDIT_MESSAGE = 'room.edit-message';
export const EDIT_FILE_MESSAGE_HINT = 'room.edit-file-message.hint';
export const EDIT_NON_TEXT_MESSAGE_HINT = 'room.edit-non-text-message.hint';
export const EDIT_MESSAGE_LIMIT_HINT = 'room.edit-message.limit.hint';
export const CONFIRM_MESSAGE_DELETION = 'room.delete-message.confirmation-popup';
export const YES = 'yes';
export const NO = 'no';
